import { bootstrapApplication } from '@angular/platform-browser';

import { SentryService } from '@f4rm/app-core/services/sentry/sentry.service';

import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';

SentryService.init(environment.config.sentry);

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => {
    console.error('Application bootstrap failed:', err);
  });
